

export const urls={
    redirect_url_test: 'https://ecoforce-calc-test.dupont.com/',
    redirect_url_local: 'http://localhost:3000/',
}